import { Page } from '../pages/policy/contacts';

export default function () {
  return (
    <Page />
  );
};
